import { render } from "./CardMedium.vue?vue&type=template&id=2177d9b7&scoped=true"
import script from "./CardMedium.vue?vue&type=script&lang=js"
export * from "./CardMedium.vue?vue&type=script&lang=js"

import "./CardMedium.vue?vue&type=style&index=0&id=2177d9b7&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2177d9b7"]])

export default __exports__